import { getCurrentInstance } from 'vue'
import { getDomain, get } from '../../../utils/index'

export function useHeaderUser() {
  const { proxy } = getCurrentInstance()
  const ssoRequest = proxy.$SsoRequest

  const toPassport = async () => {
    let path = ''
    let tokenId = ssoRequest.getToken(ssoRequest)
    let url = getDomain(
      proxy.GLOBAL.passportServerURL + '/rest/security/auth/getTicketByToken?tokenId=' + tokenId
    )
    const [resData] = await get(url)
    if (resData) {
      if (proxy.GLOBAL.ssoLoginUrl.indexOf('#') > 0) {
        path =
          proxy.GLOBAL.ssoLoginUrl.substring(0, proxy.GLOBAL.ssoLoginUrl.indexOf('#')) +
          'index.html#/index/index_home?ticket=' +
          resData.data
      }
      window.open(getDomain(path))
    }
  }

  const logout = async () => {
    var ssoToken = ssoRequest.getToken(ssoRequest)
    const [resData] = await get(`rest/security/login/logoutByToken?tokenId=${ssoToken}`)
    if (resData) {
      if (sessionStorage.getItem('forceSubmit')) {
        sessionStorage.removeItem('forceSubmit')
      }
      proxy.$store.commit('logout')
      if (proxy.$store.state.strategy) proxy.$store.commit('clearStrategy')
      ssoRequest.gotoSSOLogin()
    }
  }

  const toHelp = () => {
    if (!proxy.GLOBAL.helpUrl) return
    let path =
      proxy.GLOBAL.helpUrl +
      '?ticket=' +
      ssoRequest.getTicketId(proxy.GLOBAL?.ticketIdKey ? proxy.GLOBAL : ssoRequest)
    window.open(getDomain(path))
  }
  return {
    toPassport,
    logout,
    toHelp,
  }
}
